import { dateFormate } from "@constants/index";
import dayjs from "dayjs";

const FormatDate=(dbDateValue:any)=>{
    return dayjs(dbDateValue).format(dateFormate.yyyy_mm_dd);
}
export default FormatDate;